module.exports = __webpack_public_path__ + "static/media/4-5.c0946f89.mp3";